<script>
import VxTimeLine from "@/components/timeline/VxTimeline.vue";
import moment from "moment/moment";
import { Russian } from "flatpickr/dist/l10n/ru.js";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  components: { VxTimeLine, flatPickr },
  props: {
    modalValue: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tempId: null,
      bigModal: false,
      commentsData: [],
      formDataComment: {
        comment: null,
        daily_emission_id: null,
      },
      formData: {
        datetime: moment().format("DD-MM-YYYY"), // время
      },
      config: {
        maxDate: "today",
        locale: Russian,
        dateFormat: "d-m-Y",
      },
    };
  },
  methods: {
    openBigModal() {
      this.bigModal = true;
    },

    sendComment() {
      let req = {
        description: this.formDataComment.comment,
        id: this.modalValue.id,
        status_id: 2,
      };
      this.$store
        .dispatch("emissions/changeModerationEmissionStatus", req)
        .then(() => {
          this.successNotifySave();
          this.formDataComment.comment = "";

          this.$store
            .dispatch("emissions/fetchCommentsDailyPollutionEmissions", {
              daily_emission_id: this.modalValue.id,
            })
            .then((res) => {
              this.generateArrayComments(res);
              this.bigModal = false;

              this.$emit("update");
            });
        })
        .catch((err) => {
          this.errNotifySave();
        });
    },

    generateArrayComments(value) {
      this.commentsData = [];
      value.data.data.forEach((element) => {
        let newObj = new Object();
        newObj = {
          color: "primary",
          icon: "PlusIcon",
          title: element.owner.username,
          desc: element.comment_text,
          time: moment(element.created_at).locale("ru").format("lll"),
        };
        this.commentsData.push(newObj);
        console.log(this.commentsData);
      });
    },

    successNotifySave() {
      this.$vs.notify({
        title: this.$t("saved"),
        text: "",
        color: "success",
      });
    },

    errNotifySave(value = "") {
      if (typeof value === "string") {
        var errMsg = ": " + value;
      } else {
        var errMsg = "";
      }
      this.$vs.notify({
        title: this.$t("error"),
        text: this.$t("can_not_saved")` ${value}`,
        color: "danger",
      });
    },
  },
  watch: {
    "modalValue.id": {
      handler(val) {
        if (val) {
          this.$store
            .dispatch("emissions/fetchCommentsDailyPollutionEmissions", {
              daily_emission_id: this.modalValue.id,
            })
            .then((res) => {
              this.generateArrayComments(res);
            });
        }
      },
    },
  },
};
</script>

<template>
  <vs-popup
    :active.sync="bigModal"
    fullscreen
    class="holamundo"
    title="Пыль (хлопковая)"
  >
    <div class="flex flex-col justify-between h-full">
      <div class="vx-row">
        <div class="vx-col w-1/2">
          <h6 class="w-full text-center">Список коментариев пуст</h6>
          <div class="vx-row m-3 overflow-y-auto" style="height: 50vh">
            <vx-time-line :data="commentsData"></vx-time-line>
          </div>
          <div class="vx-col w-full mb-2">
            <label for="formData.comment">Новый коментарии</label>
            <vs-input
              v-model="formDataComment.comment"
              class="mb-2 w-full"
              id="text-area"
            />

            <vs-button @click="sendComment">
              Сохранить и отправить комментарий
            </vs-button>
          </div>
        </div>

        <div class="vx-col w-1/2">
          <div class="vx-row">
            <div class="vx-col">
              <div class="vx-row">
                <div class="vx-col w-full mb-2">
                  <h6>{{ $t("modals.inn") }}</h6>
                  <p v-if="modalValue.source">
                    {{ modalValue.source.company_object.inn }}
                  </p>
                </div>
                <div class="vx-col w-full mb-2">
                  <h6>{{ $t("filters.districts") }}</h6>
                  <p v-if="modalValue.source">
                    {{
                      modalValue.source.region.parent
                        ? modalValue.source.region.parent.region_kir
                        : modalValue.source.region.region_kir
                    }}
                  </p>
                </div>
                <div class="vx-col w-full mb-2">
                  <h6>{{ $t("Company") }}</h6>
                  <p v-if="modalValue.source">
                    {{ modalValue.source.company_object.title }}
                  </p>
                </div>

                <div class="vx-col w-full mb-2 flex items-center">
                  <div class="vx-col w-1/2">
                    <h6>{{ $t("modules.geology.date") }}</h6>

                    <p v-if="modalValue.source">
                      {{ modalValue.date }}
                    </p>
                  </div>
                  <div class="vx-col w-1/2">
                    <label for="formData.datetime">
                      {{ $t("modules.geology.date") }}
                    </label>
                    <flat-pickr
                      disabled
                      v-model="formData.datetime"
                      :placeholder="$t('filters.choose_date')"
                      class="w-full mb-3"
                      :config="config"
                    />
                  </div>
                </div>
                <div class="vx-col w-full mb-2 flex items-center">
                  <div class="vx-col w-1/2">
                    <h6>Старое значение</h6>
                    <p v-if="modalValue.old_value">
                      {{ modalValue.old_value }}
                    </p>
                  </div>

                  <div class="vx-col w-1/2">
                    <label for="formData.value">Значение </label>
                    <vs-input
                      disabled
                      class="w-full"
                      v-model="modalValue.value"
                      type="number"
                    ></vs-input>
                  </div>
                </div>
                <div class="vx-col w-full mb-2">
                  <h6>{{ $t("source_number") }}</h6>
                  <p v-if="modalValue.source">
                    {{ modalValue.source.number }}
                  </p>
                </div>
                <div class="vx-col w-full mb-2">
                  <h6>{{ $t("source_name") }}</h6>
                  <p v-if="modalValue.source">
                    {{ modalValue.source.name }}
                  </p>
                </div>
                <div class="vx-col w-full mb-2">
                  <h6>Ингредиент</h6>
                  <p v-if="modalValue.component">
                    {{ modalValue.component.name }}
                  </p>
                </div>
                <div class="vx-col w-full mb-2">
                  <h6>Норматив</h6>
                  <p v-if="modalValue.source">
                    <!-- {{ formData.source   }} -->
                    Норматив
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </vs-popup>
</template>
